import { Component, OnInit, AfterViewChecked, ChangeDetectorRef, AfterViewInit, ViewChild, ElementRef } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import Swal from "sweetalert2";
import { CustomerService } from "src/app/services/customer.service";
import { NgbTypeaheadConfig } from '@ng-bootstrap/ng-bootstrap';
import { Observable, OperatorFunction, Subscription, debounceTime, distinctUntilChanged, finalize, forkJoin, lastValueFrom, map } from "rxjs";
import { AddressBookService } from "src/app/services/general/addressbook.service";
import { PickupService } from "src/app/services/operations/pickup.service";
import { NetworkService } from "src/app/services/network.service";
import { UserManagementService } from "src/app/services/user-management.service";
import { AppCoreService } from "src/app/services/app-core.service";
import { EmailValidation, MobileNumberValidation, TelephoneNumberValidation } from "src/app/models/validator";
import { ConfigService } from "src/app/services/system-config/configs/configs.service";
import { FileHandlerService } from "src/app/services/file-handler.service";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Utilities } from "src/app/models/utilities";
import { Title } from "@angular/platform-browser";
import { AgGridAngular } from "ag-grid-angular";
import { NgSelectComponent } from "@ng-select/ng-select";
import { AddressComponent } from "src/app/components/shared/address/address.component";
import { GeoService } from "src/app/services/geo.service";

@Component({
  selector: 'app-editpickup',
  templateUrl: './editpickup.component.html',
  styleUrls: ['./editpickup.component.scss'],
})
export class EditPickupComponent implements OnInit, AfterViewChecked, AfterViewInit {

  @ViewChild('agGrid') agGrid: AgGridAngular;
  @ViewChild('shipperNameRef') shipperNameRef: ElementRef;
  @ViewChild('fieldExecutiveRef') fieldExecutiveRef: NgSelectComponent;
  @ViewChild('salesExecutiveRef') salesExecutiveRef: NgSelectComponent;

  pickupId: string;
  pickupForm: FormGroup;
  isFormSubmitted: boolean;
  permConfig = {
    isViewAllowed: false,
    isAddAllowed: false,
    isEditAllowed: false,
    isDeleteAllowed: false
  };
  customerList: any[] = [];
  shipperAddressBookList = [];
  consigneeAddressBookList = [];
  resAddressBookList = [];
  vehicleTypes = [];
  ServiceCenterOptions: [];
  fieldExecutiveList: any[];
  salesExecutiveList: any[];
  statusType: any[] = ["Assigned", 'Confirm'];
  shipperLocationInfo: any;
  consigneeLocationInfo: any;

  isShipperCustomerBinded = false;
  focusConsigneeName: boolean = false;

  customerId: any;
  consigneeinfo: any;
  kycList: any = [];
  selectedKycFile: any;
  showProgressBar = false;
  progress = 0;
  minDateTime: string | number | Date;
  useEnterKey = false;
  matchedShipper: any = null;
  matchedConsignee: any = null;

  originCountryList = [];
  originStateList = [];
  originCityList = [];
  destinationCountryList = [];
  destinationStateList = [];
  destinationCityList = [];
  @ViewChild('appShipperAddress') appShipperAddress!: AddressComponent;
  @ViewChild('appConsigneeAddress') appConsigneeAddress!: AddressComponent;
  private consigneeNameSubscription: Subscription;
  userData: any;
  userId: any;

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private customerService: CustomerService,
    private addressbookService: AddressBookService,
    private networkService: NetworkService,
    private pickupService: PickupService,
    private typeaheadConfig: NgbTypeaheadConfig,
    private readonly changeDetectorRef: ChangeDetectorRef,
    private appCoreService: AppCoreService,
    private userManagmentService: UserManagementService,
    private configService: ConfigService,
    private fileHandlerService: FileHandlerService,
    private ngxLoaderService: NgxUiLoaderService,
    private utilities: Utilities,
    private titleService: Title,
    private geoService: GeoService,
  ) {
    titleService.setTitle('Pickup');
    // typeaheadConfig.showHint = true;
    typeaheadConfig.selectOnExact = true;
  }

  selectedSCId: number;
  countryList = [];

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }
  shipperDocValidationMsg: string;
  consigneeDocValidationMsg: string;
  // documentOptions: any[] = [{ name: 'GSTIN (Normal)' }, { name: 'PAN Number' }, { name: 'Aadhaar Number' }, { name: 'Passport Number' }, { name: 'TAN Number' }, { name: 'VAT Number' }, { name: 'EORI' }, { name: 'FDA' }, { name: 'Others' }];

  assignedStatus = false;
  currentDateTime: any;
  ngOnInit(): void {
    this.vehicleTypes = ['Bike', 'Truck', 'Van'];
    this.minDateTime = this.utilities.FormatDateWithTime(0).dateTimeString;
    this.currentDateTime = this.utilities.FormatDateWithTime().dateTimeString;

    this.pickupForm = this.formBuilder.group({
      txtPickupNo: [{ disabled: true, value: null }],
      ddlCustomer: [null],
      txtDateTime: [this.currentDateTime, Validators.required],
      // txtMobile: [null, Validators.compose([Validators.required, Validators.pattern("^(\\+\\d{1,3}[- ]?)?\\d{10}$")])],
      txtContactPerson: [null, Validators.compose([Validators.maxLength(50)])],

      // txtEmailId: ["", Validators.compose([Validators.maxLength(150), Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$")])],
      txtServiceCenter: [null],
      ddlFieldExecutive: [null, Validators.maxLength(50)],
      ddlSalesExecutive: [null, Validators.maxLength(50)],
      ddlVehicleTypes: [null],
      txtSpecialInstructions: [null],
      ddlStatus: [null],
      shipperlocationdetails: this.formBuilder.group({
        ddlCountry: [null, Validators.compose([Validators.required])],
        txtName: [null, Validators.compose([Validators.required])],
        txtContactPerson: [null],
        txtEmail: [null, Validators.compose([EmailValidation, , Validators.maxLength(150)])],
        txtPincode: [null],
        ddlState: [null],
        ddlCity: [null],
        txtAddress1: [null, Validators.compose([Validators.required, Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([Validators.required, MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),

      consigneelocationdetails: this.formBuilder.group({
        ddlCountry: [null],
        txtName: [null],
        txtContactPerson: [null],
        txtEmail: [null, Validators.compose([EmailValidation, , Validators.maxLength(150)])],
        txtPincode: [null],
        ddlState: [null],
        ddlCity: [null],
        txtAddress1: [null, Validators.compose([Validators.maxLength(150)])],
        txtAddress2: [null, Validators.maxLength(150)],
        txtArea: [null, Validators.maxLength(30)],
        txtMobileNo: [null, Validators.compose([MobileNumberValidation])],
        txtTelephoneNo: [null, TelephoneNumberValidation],
      }),
    });

    this.isFormSubmitted = false;
    this.subscribeToConsigneeNameChange();

    // this.pickupForm.get('txtShipperDocumentNo').disable();
    // this.pickupForm.get('ddlShipperDocumentType')?.valueChanges.subscribe((docType) => {
    // const docNoControl = this.pickupForm.get('txtShipperDocumentNo');
    //   if (docType) {
    //     docNoControl?.enable();
    //     docNoControl?.setValidators([Validators.required]);
    //   } else {
    //     docNoControl.setValue('');
    //     docNoControl?.disable();
    //     docNoControl?.clearValidators();
    //   }
    // });

    // this.pickupForm.get('txtConsigneeDocumentNo').disable();
    // this.pickupForm.get('ddlConsigneeDocumentType')?.valueChanges.subscribe((docType) => {
    // const docNoControl = this.pickupForm.get('txtConsigneeDocumentNo');
    //   if (docType) {
    //     docNoControl?.enable();
    //     docNoControl?.setValidators([Validators.required]);
    //   } else {
    //     docNoControl.setValue('');
    //     docNoControl?.disable();
    //     docNoControl?.clearValidators();
    //   }
    // });
    this.pickupId = this.route.snapshot.params['id'];
    this.checkPermission();
    if (this.permConfig.isEditAllowed) {
      this.appCoreService.SelectedServiceCenter().subscribe(val => {
        this.selectedSCId = val;
        this.bindUsers();
        this.bindCustomers();
      })

      this.callAPIs();
    }
  }

  subscribeToConsigneeNameChange() {
    // Unsubscribe if already subscribed
    if (this.consigneeNameSubscription) {
      this.consigneeNameSubscription.unsubscribe();
    }

    // Subscribe to valueChanges
    this.consigneeNameSubscription = this.pickupForm
      .get('consigneelocationdetails.txtName')?.valueChanges.pipe(distinctUntilChanged()) // Prevent duplicate values
      .subscribe((val) => {
        if (val) {
          this.onChangeConsigneeName();
        }
      });
  }

  ngOnDestroy() {
    if (this.consigneeNameSubscription) {
      this.consigneeNameSubscription.unsubscribe();
    }
  };

  callAPIs() {
    try {
      forkJoin({
        countries: this.geoService.GetAllCountries(),
        // userdefaultlocation: this.pickupService.getUsersDefaultLocationById(this.userId),
        addressbook: this.addressbookService.GetAll({ industrytypeid: null, isactive: true, customerid: this.userData?.metaInfo?.customerid }),
        servicecenters: this.networkService.GetAllServiceCenters({ isactive: true })
      }).pipe(finalize(async () => {
        this.bindShipperLocationOverSc();
        await this.bindPickupById();
        this.applyConsigneeValidation(false);
      }
      )).subscribe({
        next: (val: any) => {
          if (val.countries.success && val?.countries?.data) {
            this.countryList = val?.countries?.data || [];
          }
          // if (val?.userdefaultlocation?.data) {
          //   const defaultLocation = val.userdefaultlocation.data?.[0]?.details;
          //   this.shipperLocationInfo = defaultLocation ? { country: defaultLocation.country, state: defaultLocation.state, city: defaultLocation.city } : null;
          // }
          if (val?.addressbook?.data) {
            // this.addressBookList = val.addressbook.data;
            // this.resAddressBookList = val.addressbook.data;
          }
          if (val?.servicecenters?.data) {
            const allocatedServiceCenters = this.appCoreService.GetUserData()?.servicecenters;
            const allServiceCenters = val.servicecenters.data;
            this.ServiceCenterOptions = allServiceCenters.filter(x => allocatedServiceCenters.some(y => y.id === x.id));
          }
        },
        error: (error) => {
          console.error(error);
        }
      });
    } catch (error) {
      console.error(error);
    }
  };


  applyConsigneeValidation(apply: boolean = false) {
    if (apply) {
      this.mandateConsigneeForm();
    } else {
      this.resetConsigneeForm();
    }
  }

  ngAfterViewInit(): void {
    this.useEnterKey ? this.utilities.focusFirstElement(this.pickupForm) : null;
  }

  checkPermission(): any {
    this.userData = this.appCoreService.GetUserData();
    this.useEnterKey = !this.userData.metaInfo.tabbasedtemplate;
    this.userId = this.userData?.userId;
    const permission = this.userData.config.filter(x => x.categoryname === 'Pickups');
    if (permission.length) {
      this.permConfig.isViewAllowed = permission[0].view;
      this.permConfig.isAddAllowed = permission[0].add;
      this.permConfig.isEditAllowed = permission[0].edit;
      this.permConfig.isDeleteAllowed = permission[0].delete;
    }
  }

  resetConsigneeForm() {
    const consigneeForm = this.pickupForm.get('consigneelocationdetails') as FormGroup;

    if (!consigneeForm) return;

    const controlsToClear = ['txtConsignee', 'txtConsigneeEmail', 'txtConsigneeContactPerson'];

    // Clear validators and update validity for controls in pickupForm
    controlsToClear.forEach(control => {
      const ctrl = this.pickupForm.get(control);
      if (ctrl) {
        ctrl.clearValidators();
        ctrl.updateValueAndValidity();
        ctrl.reset();
      }
    });

    // Clear validators, update validity, and reset controls inside consigneelocationdetails
    Object.keys(consigneeForm.controls).forEach(control => {
      const ctrl = consigneeForm.get(control);
      if (ctrl) {
        ctrl.clearValidators();
        ctrl.updateValueAndValidity();
        ctrl.reset();
      }
    });

    // Reset the whole consignee location form
    consigneeForm.reset();
  }


  async bindPickupById() {
    const res = await lastValueFrom(this.pickupService.GetById(this.pickupId));
    if (res && res.success) {
      const resData = res.data[0];
      // console.log('fieldexecutiveid',resData.fieldexecutiveid)
      const shipper = resData.details.filter(x => x.type === 'Shipper');
      const consignee = resData.details.filter(x => x.type === 'Consignee');
      this.pickupForm.controls.ddlCustomer.setValue(resData.customerid)
      this.pickupForm.controls.txtDateTime.setValue(resData.pickupdate)

      this.pickupForm.patchValue({
        txtPickupNo: resData.pickupNo,
        ddlCustomer: this.customerList.find(x => x.id == resData.customerid)?.id,
        txtDateTime: resData.pickupdate,
        txtServiceCenter: parseInt(resData.servicecenterid) || null,
        ddlFieldExecutive: parseInt(resData.fieldexecutiveid) || null,
        ddlSalesExecutive: parseInt(resData.salesexecutiveid) || null,
        ddlVehicleTypes: resData.vehicletype || null,
        txtSpecialInstructions: resData.specialinstructions,
        ddlStatus: resData.status === 'Assigned' ? this.statusType[0] : resData.status

      });
      this.onChangeStatus(true);
      this.kycList = resData?.kyc ?? [];
      this.assignedStatus = resData?.status === 'Assigned';

      // WHEN h.transactionstatus = 'SHIPMENT_ASSIGNED_TO_FE' THEN 'Assigned'
      // WHEN h.transactionstatus = 'SHIPMENT_PU_CONFIRMED_BY_FE' THEN 'Confirm'
      // WHEN h.transactionstatus = 'PICKUP_VOID' THEN 'void'
      //// bind location details for child component
      // this.shipperLocationInfo = shipper[0]?.location;
      this.shipperLocationInfo = {
        ...this.shipperLocationInfo,
        ...shipper?.[0] // Merges entire `shipper[0]` object, keeping all properties
      };

      // console.log(this.shipperLocationInfo);
      if (consignee?.info?.name) {
        this.consigneeLocationInfo = {
          ...this.consigneeLocationInfo,
          ...consignee?.[0] // Merges entire `shipper[0]` object, keeping all properties
        };
      }
      // this.kycList = resData.pickupkyc;
    }
  }



  onChangeStatus(onBind?: boolean) {
    onBind ? null : this.pickupForm.get('ddlFieldExecutive').reset();
    if (this.pickupForm.get('ddlStatus').value === 'Assigned') {
      this.assignedStatus = true;
      this.pickupForm.get('ddlFieldExecutive').setValidators([Validators.required]);
    } else {
      this.assignedStatus = false;
      this.pickupForm.get('ddlFieldExecutive').clearValidators();
    }
    this.pickupForm.get('ddlFieldExecutive').updateValueAndValidity();
  }

  bindUsers() {
    try {
      this.userManagmentService.GetUserByGroup('fe,se', this.appCoreService.GetUserData().selectedServiceCenter).subscribe((res) => {
        if (res && res.success) {
          const data = res.data;
          this.fieldExecutiveList = data.filter((item: any) => item.usergroupname === 'Field Executive');
          this.salesExecutiveList = data.filter((item: any) => item.usergroupname === 'Sales Executive');
        }
      })
    }
    catch (err) {
      console.error(err);
    }
  }


  onChangeConsigneeName() {
    if (this.pickupForm.get('consigneelocationdetails.txtName').value) {
      this.applyConsigneeValidation(true);
    } else {
      this.pickupForm.get('consigneelocationdetails')?.reset();
      this.applyConsigneeValidation(false);
    }
  }

  mandateConsigneeForm() {
    const consigneeForm = this.pickupForm.get('consigneelocationdetails') as FormGroup;
    if (!consigneeForm) return;

    const controlsToMandate = ['txtConsignee'];
    const consigneeControlsToMandate = ['ddlCountry', 'ddlState', 'ddlCity', 'txtAddress1', 'txtMobileNo'];

    // Set required validators for controls in pickupForm
    controlsToMandate.forEach(control => {
      const ctrl = this.pickupForm.get(control);
      if (ctrl) {
        ctrl.setValidators([Validators.required]);
        ctrl.updateValueAndValidity();
      }
    });

    // Set required validators for all controls inside consigneelocationdetails
    Object.keys(consigneeForm.controls).forEach(control => {
      const ctrl = consigneeForm.get(control);
      if (ctrl && consigneeControlsToMandate.includes(control)) {
        ctrl.setValidators([Validators.required]);
      } else {
        ctrl.clearValidators();
      }
      ctrl.updateValueAndValidity();
    });
  }

  async updatePickup() {
    let pickupForm = this.pickupForm;
    let shipperlocation = pickupForm.get('shipperlocationdetails');
    let consigneelocation = pickupForm.get('consigneelocationdetails');

    if (!this.permConfig.isEditAllowed) {
      this.warningDialog('You dont have permission to edit');
      return;
    }

    this.isFormSubmitted = true;
    if (!this.pickupForm.valid)
      return;


    if (shipperlocation.get('txtName').invalid || shipperlocation.invalid) {
      await this.warningDialog('Please Enter Shipper details');
      setTimeout(() => {
        this.shipperNameRef.nativeElement.focus();
      }, 300)
      return;
    }

    const customer = this.pickupForm.get('ddlCustomer')?.value;
    const consigneeForm = this.pickupForm.get('consigneelocationdetails');
    const consigneeObj = consigneeForm.get('txtName');
    if ((consigneeForm.invalid) || (consigneeObj.invalid)) {
      this.warningDialog('Please enter consignee details OR Reset the form');
      return;
    }

    if (this.pickupForm.invalid) {
      return;
    }

    let details = [];
    //check details 
    const shipperNameValue: any = this.pickupForm.get('shipperlocationdetails.txtName')?.value;
    let shipperName = shipperNameValue ? (typeof shipperNameValue === 'string' ? shipperNameValue?.toUpperCase()?.trim() : shipperNameValue?.name?.toUpperCase()) : null;
    let shipperArea = shipperlocation.get('txtArea').value;
    shipperArea = shipperArea ? (typeof shipperArea === 'string' ? shipperArea : shipperArea?.area) : null;
    let shipperPincode = shipperlocation.get('txtPincode')?.value;
    shipperPincode = shipperPincode ? (typeof shipperPincode === 'string' ? shipperPincode : shipperPincode?.pincode) : null;

    const consigneeNameValue: any = this.pickupForm.get('consigneelocationdetails.txtName')?.value;
    let consigneeName = shipperNameValue ? (typeof consigneeNameValue === 'string' ? consigneeNameValue?.toUpperCase()?.trim() : consigneeNameValue?.name?.toUpperCase()) : null;
    let consigneeArea = consigneelocation.get('txtArea').value;
    consigneeArea = consigneeArea? (typeof consigneeArea === 'string' ? consigneeArea : consigneeArea?.area): null;
    let consigneePincode = consigneelocation.get('txtPincode')?.value;
    consigneePincode = consigneePincode? (typeof consigneePincode === 'string' ? consigneePincode : consigneePincode?.pincode): null;
   
    details.push({
      info: {
        type: 'Shipper',
        name: shipperName,
        contactperson: shipperlocation.get('txtContactPerson')?.value?.trim()?.toUpperCase() || null,
        emailid: shipperlocation.get('txtEmail')?.value?.trim()?.toUpperCase() || null,
        location: {
          country: shipperlocation.get('ddlCountry')?.value?.trim(),
          state: shipperlocation.get('ddlState')?.value?.trim() || null,
          city: shipperlocation.get('ddlCity')?.value?.trim() || null,
          pincode: shipperPincode? shipperPincode?.trim()?.toUpperCase(): null,
          address1: shipperlocation.get('txtAddress1')?.value?.trim(),
          address2: shipperlocation.get('txtAddress2')?.value?.trim() || null,
          mobileno: Number(shipperlocation.get('txtMobileNo')?.value),
          tel: shipperlocation.get('txtTelephoneNo')?.value?.trim() || null,
          area: shipperArea? shipperArea?.trim()?.toUpperCase(): null
        },
        // kyc: {
        //   type: this.pickupForm.get('ddlShipperDocumentType')?.value,
        //   no: this.pickupForm.get('txtShipperDocumentNo')?.value
        // },
        generatedby: this.appCoreService.GetUserData().accessType,
        generatedfromid: this.appCoreService.GetUserData().selectedServiceCenter,
        customerid: customer
      },
    });

    // check for consignee value
    if (consigneeName) {
      details.push({
        info: {
          type: 'Consignee',
          name: consigneeName?.toUpperCase().trim(),
          contactperson: consigneelocation.get('txtContactPerson')?.value?.trim()?.toUpperCase() || null,
          emailid: consigneelocation.get('txtEmail')?.value?.trim()?.toUpperCase() || null,
          location: {
            country: consigneelocation.get('ddlCountry')?.value?.trim(),
            state: consigneelocation.get('ddlState')?.value?.trim() || null,
            city: consigneelocation.get('ddlCity')?.value?.trim() || null,
            pincode: consigneePincode? consigneePincode?.trim()?.toUpperCase(): null,
            address1: consigneelocation.get('txtAddress1')?.value?.trim(),
            address2: consigneelocation.get('txtAddress2')?.value?.trim() || null,
            mobileno: Number(consigneelocation.get('txtMobileNo')?.value),
            tel: consigneelocation.get('txtTelephoneNo')?.value?.trim() || null,
            area: consigneeArea? consigneeArea?.trim()?.toUpperCase(): null
          },
          // kyc: {
          //   type: this.pickupForm.get('ddlConsigneeDocumentType')?.value,
          //   no: this.pickupForm.get('txtConsigneeDocumentNo')?.value
          // },
          generatedby: this.appCoreService.GetUserData().accessType,
          generatedfromid: this.appCoreService.GetUserData().selectedServiceCenter,
          customerid: customer
        },
      });
    }

    const requestObj = {
      id: this.pickupId,
      customerid: pickupForm.get('ddlCustomer')?.value,
      pickupdate: pickupForm.get('txtDateTime')?.value,
      details,
      servicecenterid: pickupForm.get('txtServiceCenter')?.value,
      fieldexecutiveid: pickupForm.get('ddlFieldExecutive')?.value,
      salesexecutiveid: pickupForm.get('ddlSalesExecutive')?.value,
      vehicletype: pickupForm.get('ddlVehicleTypes')?.value,
      specialinstructions: pickupForm.get('txtSpecialInstructions')?.value,
      status: pickupForm.get('ddlStatus')?.value,
    }

    // console.log('requestObj', requestObj);

    this.ngxLoaderService.start();
    this.pickupService.Update(requestObj).subscribe((res) => {
      try {
        if (res && res.success) {
          this.ngxLoaderService.stop();
          this.openConfirmationDialog("Record update successfully");
          this.resetForm();
        } else if (res?.success) {
          this.ngxLoaderService.stop();
        }
      }
      catch (err) {
        this.ngxLoaderService.stop();
        console.error(err);
      }
    });
  }

  async bindCustomerShipperInfo() {
    //this.getAWBCharges();
    const customerId = this.pickupForm.get('ddlCustomer')?.value;
    const customerData: any = this.customerList.filter(x => x.id === customerId);

    if (customerId && customerData[0]?.customertype !== "Co-Courier") {
      this.isShipperCustomerBinded = true;

      this.shipperLocationInfo = {
        ...this.shipperLocationInfo,
        location: customerData?.[0]?.location ?? {},
        info: {
          name: customerData?.[0]?.name,
          emailid: customerData?.[0]?.emailid,
          contactperson: customerData?.[0]?.contactperson
        }
      }
    }
  };

  async warningDialog(msg: any) {
    await Swal.fire({
      title: 'Error!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
  }

  bindShipperLocationOverSc() {
    this.networkService.GetServiceCentersById(this.selectedSCId).subscribe((res) => {
      if (res && res.success) {
        let location = res?.data[0]?.location;
        if (location) {
          // this.shipperLocationInfo = {
          //   ...this.shipperLocationInfo,
          //   country: location.country,
          //   state: location.state,
          //   city: location.city
          // }
          this.shipperLocationInfo = {
            ...this.shipperLocationInfo,
            location: {
              country: location.country,
              state: location.state,
              city: location.city
            }
          }
        }
      }
    })
  }

  manageStatusChangeFocus() {
    setTimeout(() => {
      this.assignedStatus ? this.fieldExecutiveRef.focus() : this.salesExecutiveRef.focus()
    }, 200)
  }
  formatter = (x: { name: string }) => x.name;

  selectedItemEventShipper(e) {
    this.bindShipperLocationDetails(e?.item);
  }

  selectedItemEventConsignee(e) {
    this.bindConsigneeLocationDetails(e.item);
  }

  bindShipperLocationDetails(currLoc) {
    try {
      if (currLoc) {
        this.pickupForm.get('shipperlocationdetails.txtContactPerson').setValue(currLoc?.contactperson || null);
        this.pickupForm.get('shipperlocationdetails.txtEmail').setValue(currLoc?.emailid || null);
        this.shipperLocationInfo = {
          country: currLoc.location.country,
          state: currLoc.location.state,
          city: currLoc.location.city,
          area: currLoc.location.area,
          address1: currLoc.location.address1,
          address2: currLoc.location.address2,
          pincode: currLoc.location.pincode,
          mobileno: currLoc.location.mobileno,
          tel: currLoc.location.tel,
        };
      }
    } catch (e) {

    }
  }

  bindConsigneeLocationDetails(currLoc) {
    try {
      if (currLoc) {
        this.pickupForm.get('txtConsigneeContactPerson').setValue(currLoc?.contactperson || null);
        this.pickupForm.get('txtConsigneeEmail').setValue(currLoc?.emailid || null);
        this.consigneeLocationInfo = {
          country: currLoc.location.country,
          state: currLoc.location.state,
          city: currLoc.location.city,
          area: currLoc.location.area,
          address1: currLoc.location.address1,
          address2: currLoc.location.address2,
          pincode: currLoc.location.pincode,
          mobileno: currLoc.location.mobileno,
          tel: currLoc.location.tel,
        };
      }
    } catch (e) {

    }
  }


  handleBlankDropDownValues(value: any) {
    let returnValue = null;
    if (value) {
      if (Array.isArray(value)) {
        returnValue = null;
      } else {
        returnValue = value;
      }
    }
    return returnValue;
  }

  bindCustomers() {
    try {
      this.customerService.GetAll({ scid: this.appCoreService.GetUserData().selectedServiceCenter }).subscribe((res) => {
        if (res && res.success) {
          this.customerList = res.data;
        } else {
        }
      });
    } catch (e) {
      console.error(e);
    }
  }

  // bindCustomerShipperInfo()
  // {
  //   const customerData:any=this.customerList.filter(x=>x.id===this.customerId);
  //   const shipper = this.pickupForm.get('txtShipper').value;
  //   if(customerData[0]?.customertype=="Co-Courier")
  //   {
  //     this.shipperLocationInfo=customerData.length ? (customerData[0]?.location==null?{} : customerData[0]?.location):{};
  //     const name={name:customerData[0].name}
  //     this.pickupForm.patchValue({
  //       txtShipper:name,
  //       txtContactPerson:customerData[0]?.contactperson,
  //       txtMobile:customerData[0].mobile
  //     });
  //     const shipper = this.pickupForm.get('txtShipper').value;
  //   }
  // }

  resetForm(): void {
    this.pickupForm.reset();
    this.isFormSubmitted = false;
  }

  async openConfirmationDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      title: 'Success!',
      text: msg,
      icon: 'success',
      confirmButtonText: 'OK',
      allowEscapeKey: false,
      allowOutsideClick: false
    })
    if (result.isConfirmed) {
      this.router.navigate(['/operation/pickups']);
    }

  }

  async openWarningDialog(msg: any, id?: number) {
    const result = await Swal.fire({
      // title: 'Success!',
      text: msg,
      icon: 'warning',
      confirmButtonText: 'OK',
      showCancelButton: true,
      allowEscapeKey: false,
      allowOutsideClick: false
    });
    return result.isConfirmed;
  }

  validateDate(): void {
    const enteredDate = new Date(this.pickupForm.get('txtDateTime')?.value);
    const minAllowedDate = new Date(this.minDateTime);

    if (isNaN(enteredDate.getTime()) || isNaN(minAllowedDate.getTime())) {
      // If either date is invalid, set an error (optional)
      this.pickupForm.get('txtDateTime')?.setErrors({ invalidDate: true });
      return;
    }

    if (enteredDate < minAllowedDate) {
      this.pickupForm.get('txtDateTime')?.setErrors({ minDate: true });
    } else {
      this.pickupForm.get('txtDateTime')?.setErrors(null);
    }
  }

  getAddressbookList(event: any) {
    event.listType === 'origin' ? this.shipperAddressBookList = event.addressbook : this.consigneeAddressBookList = event.addressbook;
  }

  getOriginLocation(location: any) {
    this.originCountryList = location?.[0]?.country || [];
    this.originStateList = location?.[0]?.state || [];
    this.originCityList = location?.[0]?.city || [];
  }

  getDestinationLocation(location: any) {
    this.destinationCountryList = location?.[0]?.country || [];
    this.destinationStateList = location?.[0]?.state || [];
    this.destinationCityList = location?.[0]?.city || [];
  }

}